import React from 'react';
import { Link } from 'gatsby';

type MdxLinkProps = {
  children: React.ReactNode;
  href: string;
};

const MdxLink: React.FC<MdxLinkProps> = ({ href, children }) => {
  const isInternalLink = href && href.startsWith('/');

  if (isInternalLink) {
    return <Link to={href} className='underline hover:text-slate-600 dark:hover:text-slate-200'>{children}</Link>;
  }

  return (
    <a className='underline hover:text-slate-600 dark:hover:text-slate-200' href={href}>
      {children}
    </a>
  );
};
export default MdxLink;
